// Auto-generated from Steel_Sections_1.xlsx
export const STEEL_SECTIONS = {
  "IPE Sections": [
    {
      "name": "IPE80",
      "h": 80.0,
      "b": 46.0,
      "tw": 3.8,
      "tf": 5.2,
      "r1": 5.0
    },
    {
      "name": "IPE100",
      "h": 100.0,
      "b": 55.0,
      "tw": 4.1,
      "tf": 5.7,
      "r1": 7.0
    },
    {
      "name": "IPE120",
      "h": 120.0,
      "b": 64.0,
      "tw": 4.4,
      "tf": 6.3,
      "r1": 7.0
    },
    {
      "name": "IPE140",
      "h": 140.0,
      "b": 73.0,
      "tw": 4.7,
      "tf": 6.9,
      "r1": 7.0
    },
    {
      "name": "IPE160",
      "h": 160.0,
      "b": 82.0,
      "tw": 5.0,
      "tf": 7.4,
      "r1": 9.0
    },
    {
      "name": "IPE180",
      "h": 180.0,
      "b": 91.0,
      "tw": 5.3,
      "tf": 8.0,
      "r1": 9.0
    },
    {
      "name": "IPE200",
      "h": 200.0,
      "b": 100.0,
      "tw": 5.6,
      "tf": 8.5,
      "r1": 12.0
    },
    {
      "name": "IPE220",
      "h": 220.0,
      "b": 110.0,
      "tw": 5.9,
      "tf": 9.2,
      "r1": 12.0
    },
    {
      "name": "IPE240",
      "h": 240.0,
      "b": 120.0,
      "tw": 6.2,
      "tf": 9.8,
      "r1": 15.0
    },
    {
      "name": "IPE270",
      "h": 270.0,
      "b": 135.0,
      "tw": 6.6,
      "tf": 10.2,
      "r1": 15.0
    },
    {
      "name": "IPE300",
      "h": 300.0,
      "b": 150.0,
      "tw": 7.1,
      "tf": 10.7,
      "r1": 15.0
    },
    {
      "name": "IPE330",
      "h": 330.0,
      "b": 160.0,
      "tw": 7.5,
      "tf": 11.5,
      "r1": 18.0
    },
    {
      "name": "IPE360",
      "h": 360.0,
      "b": 170.0,
      "tw": 8.0,
      "tf": 12.7,
      "r1": 18.0
    },
    {
      "name": "IPE400",
      "h": 400.0,
      "b": 180.0,
      "tw": 8.6,
      "tf": 13.5,
      "r1": 21.0
    },
    {
      "name": "IPE450",
      "h": 450.0,
      "b": 190.0,
      "tw": 9.4,
      "tf": 14.6,
      "r1": 21.0
    },
    {
      "name": "IPE500",
      "h": 500.0,
      "b": 200.0,
      "tw": 10.2,
      "tf": 16.0,
      "r1": 21.0
    },
    {
      "name": "IPE550",
      "h": 550.0,
      "b": 210.0,
      "tw": 11.1,
      "tf": 17.2,
      "r1": 24.0
    },
    {
      "name": "IPE600",
      "h": 600.0,
      "b": 220.0,
      "tw": 12.0,
      "tf": 19.0,
      "r1": 24.0
    }
  ],
  "HEA Sections": [
    {
      "name": "HEA100",
      "h": 96.0,
      "b": 100.0,
      "tw": 5.0,
      "tf": 8.0,
      "r1": 12.0
    },
    {
      "name": "HEA120",
      "h": 114.0,
      "b": 120.0,
      "tw": 5.0,
      "tf": 8.0,
      "r1": 12.0
    },
    {
      "name": "HEA140",
      "h": 133.0,
      "b": 140.0,
      "tw": 5.5,
      "tf": 8.5,
      "r1": 12.0
    },
    {
      "name": "HEA160",
      "h": 152.0,
      "b": 160.0,
      "tw": 6.0,
      "tf": 9.0,
      "r1": 15.0
    },
    {
      "name": "HEA180",
      "h": 171.0,
      "b": 180.0,
      "tw": 6.0,
      "tf": 9.5,
      "r1": 15.0
    },
    {
      "name": "HEA200",
      "h": 190.0,
      "b": 200.0,
      "tw": 6.5,
      "tf": 10.0,
      "r1": 18.0
    },
    {
      "name": "HEA220",
      "h": 210.0,
      "b": 220.0,
      "tw": 7.0,
      "tf": 11.0,
      "r1": 18.0
    },
    {
      "name": "HEA240",
      "h": 230.0,
      "b": 240.0,
      "tw": 7.5,
      "tf": 12.0,
      "r1": 21.0
    },
    {
      "name": "HEA260",
      "h": 250.0,
      "b": 260.0,
      "tw": 7.5,
      "tf": 12.5,
      "r1": 24.0
    },
    {
      "name": "HEA280",
      "h": 270.0,
      "b": 280.0,
      "tw": 8.0,
      "tf": 13.0,
      "r1": 24.0
    },
    {
      "name": "HEA300",
      "h": 290.0,
      "b": 300.0,
      "tw": 8.5,
      "tf": 14.0,
      "r1": 27.0
    },
    {
      "name": "HEA320",
      "h": 310.0,
      "b": 300.0,
      "tw": 9.0,
      "tf": 15.5,
      "r1": 27.0
    },
    {
      "name": "HEA340",
      "h": 330.0,
      "b": 300.0,
      "tw": 9.5,
      "tf": 16.5,
      "r1": 27.0
    },
    {
      "name": "HEA360",
      "h": 350.0,
      "b": 300.0,
      "tw": 10.0,
      "tf": 17.5,
      "r1": 27.0
    },
    {
      "name": "HEA400",
      "h": 390.0,
      "b": 300.0,
      "tw": 11.0,
      "tf": 19.0,
      "r1": 27.0
    },
    {
      "name": "HEA450",
      "h": 440.0,
      "b": 300.0,
      "tw": 11.5,
      "tf": 21.0,
      "r1": 27.0
    },
    {
      "name": "HEA500",
      "h": 490.0,
      "b": 300.0,
      "tw": 12.0,
      "tf": 23.0,
      "r1": 27.0
    },
    {
      "name": "HEA550",
      "h": 540.0,
      "b": 300.0,
      "tw": 12.5,
      "tf": 24.0,
      "r1": 27.0
    },
    {
      "name": "HEA600",
      "h": 590.0,
      "b": 300.0,
      "tw": 13.0,
      "tf": 25.0,
      "r1": 27.0
    },
    {
      "name": "HEA650",
      "h": 640.0,
      "b": 300.0,
      "tw": 13.5,
      "tf": 26.0,
      "r1": 27.0
    },
    {
      "name": "HEA700",
      "h": 690.0,
      "b": 300.0,
      "tw": 14.5,
      "tf": 27.0,
      "r1": 27.0
    },
    {
      "name": "HEA800",
      "h": 790.0,
      "b": 300.0,
      "tw": 15.0,
      "tf": 28.0,
      "r1": 30.0
    },
    {
      "name": "HEA900",
      "h": 890.0,
      "b": 300.0,
      "tw": 16.0,
      "tf": 30.0,
      "r1": 30.0
    },
    {
      "name": "HEA1000",
      "h": 990.0,
      "b": 300.0,
      "tw": 16.5,
      "tf": 31.0,
      "r1": 30.0
    }
  ],
  "HEB Sections": [
    {
      "name": "HEB100",
      "h": 100.0,
      "b": 100.0,
      "tw": 6.0,
      "tf": 10.0,
      "r1": 12.0
    },
    {
      "name": "HEB120",
      "h": 120.0,
      "b": 120.0,
      "tw": 6.5,
      "tf": 11.0,
      "r1": 12.0
    },
    {
      "name": "HEB140",
      "h": 140.0,
      "b": 140.0,
      "tw": 7.0,
      "tf": 12.0,
      "r1": 12.0
    },
    {
      "name": "HEB160",
      "h": 160.0,
      "b": 160.0,
      "tw": 8.0,
      "tf": 13.0,
      "r1": 15.0
    },
    {
      "name": "HEB180",
      "h": 180.0,
      "b": 180.0,
      "tw": 8.5,
      "tf": 14.0,
      "r1": 15.0
    },
    {
      "name": "HEB200",
      "h": 200.0,
      "b": 200.0,
      "tw": 9.0,
      "tf": 15.0,
      "r1": 18.0
    },
    {
      "name": "HEB220",
      "h": 220.0,
      "b": 220.0,
      "tw": 9.5,
      "tf": 16.0,
      "r1": 18.0
    },
    {
      "name": "HEB240",
      "h": 240.0,
      "b": 240.0,
      "tw": 10.0,
      "tf": 17.0,
      "r1": 21.0
    },
    {
      "name": "HEB260",
      "h": 260.0,
      "b": 260.0,
      "tw": 10.0,
      "tf": 17.5,
      "r1": 24.0
    },
    {
      "name": "HEB280",
      "h": 280.0,
      "b": 280.0,
      "tw": 10.5,
      "tf": 18.0,
      "r1": 24.0
    },
    {
      "name": "HEB300",
      "h": 300.0,
      "b": 300.0,
      "tw": 11.0,
      "tf": 19.0,
      "r1": 27.0
    },
    {
      "name": "HEB320",
      "h": 320.0,
      "b": 300.0,
      "tw": 11.5,
      "tf": 20.5,
      "r1": 27.0
    },
    {
      "name": "HEB340",
      "h": 340.0,
      "b": 300.0,
      "tw": 12.0,
      "tf": 21.5,
      "r1": 27.0
    },
    {
      "name": "HEB360",
      "h": 360.0,
      "b": 300.0,
      "tw": 12.5,
      "tf": 22.5,
      "r1": 27.0
    },
    {
      "name": "HEB400",
      "h": 400.0,
      "b": 300.0,
      "tw": 13.5,
      "tf": 24.0,
      "r1": 27.0
    },
    {
      "name": "HEB450",
      "h": 450.0,
      "b": 300.0,
      "tw": 14.0,
      "tf": 26.0,
      "r1": 27.0
    },
    {
      "name": "HEB500",
      "h": 500.0,
      "b": 300.0,
      "tw": 14.5,
      "tf": 28.0,
      "r1": 27.0
    },
    {
      "name": "HEB550",
      "h": 550.0,
      "b": 300.0,
      "tw": 15.0,
      "tf": 29.0,
      "r1": 27.0
    },
    {
      "name": "HEB600",
      "h": 600.0,
      "b": 300.0,
      "tw": 15.5,
      "tf": 30.0,
      "r1": 27.0
    },
    {
      "name": "HEB650",
      "h": 650.0,
      "b": 300.0,
      "tw": 16.0,
      "tf": 31.0,
      "r1": 27.0
    },
    {
      "name": "HEB700",
      "h": 700.0,
      "b": 300.0,
      "tw": 17.0,
      "tf": 32.0,
      "r1": 27.0
    },
    {
      "name": "HEB800",
      "h": 800.0,
      "b": 300.0,
      "tw": 17.5,
      "tf": 33.0,
      "r1": 30.0
    },
    {
      "name": "HEB900",
      "h": 900.0,
      "b": 300.0,
      "tw": 18.5,
      "tf": 35.0,
      "r1": 30.0
    },
    {
      "name": "HEB1000",
      "h": 1000.0,
      "b": 300.0,
      "tw": 19.0,
      "tf": 36.0,
      "r1": 30.0
    }
  ],
  "HEM Sections": [
    {
      "name": "HEM100",
      "h": 120.0,
      "b": 106.0,
      "tw": 12.0,
      "tf": 20.0,
      "r1": 12.0
    },
    {
      "name": "HEM120",
      "h": 140.0,
      "b": 126.0,
      "tw": 12.5,
      "tf": 21.0,
      "r1": 12.0
    },
    {
      "name": "HEM140",
      "h": 160.0,
      "b": 146.0,
      "tw": 13.0,
      "tf": 22.0,
      "r1": 12.0
    },
    {
      "name": "HEM160",
      "h": 180.0,
      "b": 166.0,
      "tw": 14.0,
      "tf": 23.0,
      "r1": 15.0
    },
    {
      "name": "HEM180",
      "h": 200.0,
      "b": 186.0,
      "tw": 14.5,
      "tf": 24.0,
      "r1": 15.0
    },
    {
      "name": "HEM200",
      "h": 220.0,
      "b": 206.0,
      "tw": 15.0,
      "tf": 25.0,
      "r1": 18.0
    },
    {
      "name": "HEM220",
      "h": 240.0,
      "b": 226.0,
      "tw": 15.5,
      "tf": 26.0,
      "r1": 18.0
    },
    {
      "name": "HEM240",
      "h": 270.0,
      "b": 248.0,
      "tw": 18.0,
      "tf": 32.0,
      "r1": 21.0
    },
    {
      "name": "HEM260",
      "h": 290.0,
      "b": 268.0,
      "tw": 18.0,
      "tf": 32.5,
      "r1": 24.0
    },
    {
      "name": "HEM280",
      "h": 310.0,
      "b": 288.0,
      "tw": 18.5,
      "tf": 33.0,
      "r1": 24.0
    },
    {
      "name": "HEM300",
      "h": 340.0,
      "b": 310.0,
      "tw": 21.0,
      "tf": 39.0,
      "r1": 27.0
    },
    {
      "name": "HEM320",
      "h": 359.0,
      "b": 309.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM340",
      "h": 377.0,
      "b": 309.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM360",
      "h": 395.0,
      "b": 308.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM400",
      "h": 432.0,
      "b": 307.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM450",
      "h": 478.0,
      "b": 307.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM500",
      "h": 524.0,
      "b": 306.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM550",
      "h": 572.0,
      "b": 306.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM600",
      "h": 620.0,
      "b": 305.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM650",
      "h": 668.0,
      "b": 305.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM700",
      "h": 716.0,
      "b": 304.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 27.0
    },
    {
      "name": "HEM800",
      "h": 814.0,
      "b": 303.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 30.0
    },
    {
      "name": "HEM900",
      "h": 910.0,
      "b": 302.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 30.0
    },
    {
      "name": "HEM1000",
      "h": 1008.0,
      "b": 302.0,
      "tw": 21.0,
      "tf": 40.0,
      "r1": 30.0
    }
  ],
  "UB Sections": [
    {
      "name": "UB127x76x13",
      "h": 127.0,
      "b": 76.0,
      "tw": 4.0,
      "tf": 7.6,
      "r1": 8.0
    },
    {
      "name": "UB152x89x16",
      "h": 152.0,
      "b": 89.0,
      "tw": 4.5,
      "tf": 7.7,
      "r1": 8.0
    },
    {
      "name": "UB178x102x19",
      "h": 178.0,
      "b": 101.0,
      "tw": 4.8,
      "tf": 7.9,
      "r1": 8.0
    },
    {
      "name": "UB203x102x23",
      "h": 203.0,
      "b": 102.0,
      "tw": 5.4,
      "tf": 9.3,
      "r1": 8.0
    },
    {
      "name": "UB203x133x25",
      "h": 203.0,
      "b": 133.0,
      "tw": 5.7,
      "tf": 7.8,
      "r1": 8.0
    },
    {
      "name": "UB203x133x30",
      "h": 207.0,
      "b": 134.0,
      "tw": 6.4,
      "tf": 9.6,
      "r1": 8.0
    },
    {
      "name": "UB254x102x22",
      "h": 254.0,
      "b": 102.0,
      "tw": 5.7,
      "tf": 6.8,
      "r1": 8.0
    },
    {
      "name": "UB254x102x25",
      "h": 257.0,
      "b": 102.0,
      "tw": 6.0,
      "tf": 8.4,
      "r1": 8.0
    },
    {
      "name": "UB254x102x28",
      "h": 260.0,
      "b": 102.0,
      "tw": 6.3,
      "tf": 10.0,
      "r1": 8.0
    },
    {
      "name": "UB254x146x31",
      "h": 251.0,
      "b": 146.0,
      "tw": 6.0,
      "tf": 8.6,
      "r1": 8.0
    },
    {
      "name": "UB254x146x37",
      "h": 256.0,
      "b": 146.0,
      "tw": 6.3,
      "tf": 10.9,
      "r1": 8.0
    },
    {
      "name": "UB254x146x43",
      "h": 260.0,
      "b": 147.0,
      "tw": 7.2,
      "tf": 12.7,
      "r1": 8.0
    },
    {
      "name": "UB305x102x25",
      "h": 305.0,
      "b": 102.0,
      "tw": 5.8,
      "tf": 7.0,
      "r1": 8.0
    },
    {
      "name": "UB305x102x28",
      "h": 309.0,
      "b": 102.0,
      "tw": 6.0,
      "tf": 8.8,
      "r1": 8.0
    },
    {
      "name": "UB305x102x33",
      "h": 313.0,
      "b": 102.0,
      "tw": 6.6,
      "tf": 10.8,
      "r1": 8.0
    },
    {
      "name": "UB305x127x37",
      "h": 304.0,
      "b": 123.0,
      "tw": 7.1,
      "tf": 10.7,
      "r1": 9.0
    },
    {
      "name": "UB305x127x42",
      "h": 307.0,
      "b": 124.0,
      "tw": 8.0,
      "tf": 12.1,
      "r1": 9.0
    },
    {
      "name": "UB305x127x48",
      "h": 311.0,
      "b": 125.0,
      "tw": 9.0,
      "tf": 14.0,
      "r1": 9.0
    },
    {
      "name": "UB305x165x40",
      "h": 303.0,
      "b": 165.0,
      "tw": 6.0,
      "tf": 10.2,
      "r1": 9.0
    },
    {
      "name": "UB305x165x46",
      "h": 307.0,
      "b": 166.0,
      "tw": 6.7,
      "tf": 11.8,
      "r1": 9.0
    },
    {
      "name": "UB305x165x54",
      "h": 310.0,
      "b": 167.0,
      "tw": 7.9,
      "tf": 13.7,
      "r1": 9.0
    },
    {
      "name": "UB356x171x45",
      "h": 351.0,
      "b": 171.0,
      "tw": 7.0,
      "tf": 9.7,
      "r1": 13.0
    },
    {
      "name": "UB356x171x51",
      "h": 355.0,
      "b": 172.0,
      "tw": 7.4,
      "tf": 11.5,
      "r1": 13.0
    },
    {
      "name": "UB356x171x57",
      "h": 358.0,
      "b": 172.0,
      "tw": 8.1,
      "tf": 13.0,
      "r1": 13.0
    },
    {
      "name": "UB356x171x67",
      "h": 363.0,
      "b": 173.0,
      "tw": 9.1,
      "tf": 15.7,
      "r1": 13.0
    },
    {
      "name": "UB406x140x39",
      "h": 398.0,
      "b": 142.0,
      "tw": 6.4,
      "tf": 8.6,
      "r1": 13.0
    },
    {
      "name": "UB406x140x46",
      "h": 403.0,
      "b": 142.0,
      "tw": 6.8,
      "tf": 11.2,
      "r1": 13.0
    },
    {
      "name": "UB406x140x53",
      "h": 407.0,
      "b": 143.0,
      "tw": 7.9,
      "tf": 12.9,
      "r1": 13.0
    },
    {
      "name": "UB406x178x54",
      "h": 403.0,
      "b": 178.0,
      "tw": 7.7,
      "tf": 10.9,
      "r1": 13.0
    },
    {
      "name": "UB406x178x60",
      "h": 406.0,
      "b": 178.0,
      "tw": 7.9,
      "tf": 12.8,
      "r1": 13.0
    },
    {
      "name": "UB406x178x67",
      "h": 409.0,
      "b": 179.0,
      "tw": 8.8,
      "tf": 14.3,
      "r1": 13.0
    },
    {
      "name": "UB406x178x74",
      "h": 413.0,
      "b": 180.0,
      "tw": 9.5,
      "tf": 16.0,
      "r1": 13.0
    },
    {
      "name": "UB406x178x85",
      "h": 417.0,
      "b": 182.0,
      "tw": 10.9,
      "tf": 18.2,
      "r1": 13.0
    },
    {
      "name": "UB457x152x52",
      "h": 450.0,
      "b": 152.0,
      "tw": 7.6,
      "tf": 10.9,
      "r1": 13.0
    },
    {
      "name": "UB457x152x60",
      "h": 455.0,
      "b": 153.0,
      "tw": 8.1,
      "tf": 13.3,
      "r1": 13.0
    },
    {
      "name": "UB457x152x67",
      "h": 458.0,
      "b": 154.0,
      "tw": 9.0,
      "tf": 15.0,
      "r1": 13.0
    },
    {
      "name": "UB457x152x74",
      "h": 462.0,
      "b": 154.0,
      "tw": 9.6,
      "tf": 17.0,
      "r1": 13.0
    },
    {
      "name": "UB457x152x82",
      "h": 466.0,
      "b": 155.0,
      "tw": 10.5,
      "tf": 18.9,
      "r1": 13.0
    },
    {
      "name": "UB457x191x67",
      "h": 453.0,
      "b": 190.0,
      "tw": 8.5,
      "tf": 12.7,
      "r1": 13.0
    },
    {
      "name": "UB457x191x74",
      "h": 457.0,
      "b": 190.0,
      "tw": 9.0,
      "tf": 14.5,
      "r1": 13.0
    },
    {
      "name": "UB457x191x82",
      "h": 460.0,
      "b": 191.0,
      "tw": 9.9,
      "tf": 16.0,
      "r1": 13.0
    },
    {
      "name": "UB457x191x89",
      "h": 463.0,
      "b": 192.0,
      "tw": 10.5,
      "tf": 17.7,
      "r1": 13.0
    },
    {
      "name": "UB457x191x98",
      "h": 467.0,
      "b": 193.0,
      "tw": 11.4,
      "tf": 19.6,
      "r1": 13.0
    },
    {
      "name": "UB457x191x106",
      "h": 469.0,
      "b": 194.0,
      "tw": 12.6,
      "tf": 20.6,
      "r1": 13.0
    },
    {
      "name": "UB457x191x133",
      "h": 481.0,
      "b": 197.0,
      "tw": 15.3,
      "tf": 26.3,
      "r1": 13.0
    },
    {
      "name": "UB457x191x161",
      "h": 492.0,
      "b": 199.0,
      "tw": 18.0,
      "tf": 32.0,
      "r1": 13.0
    },
    {
      "name": "UB460x280x113",
      "h": 463.0,
      "b": 280.0,
      "tw": 10.8,
      "tf": 17.3,
      "r1": 20.0
    },
    {
      "name": "UB460x280x128",
      "h": 467.0,
      "b": 282.0,
      "tw": 12.2,
      "tf": 19.6,
      "r1": 20.0
    },
    {
      "name": "UB460x280x144",
      "h": 472.0,
      "b": 283.0,
      "tw": 13.6,
      "tf": 22.1,
      "r1": 20.0
    },
    {
      "name": "UB460x280x158",
      "h": 476.0,
      "b": 284.0,
      "tw": 15.0,
      "tf": 23.9,
      "r1": 20.0
    },
    {
      "name": "UB460x280x177",
      "h": 482.0,
      "b": 286.0,
      "tw": 16.6,
      "tf": 26.9,
      "r1": 20.0
    },
    {
      "name": "UB460x280x193",
      "h": 489.0,
      "b": 283.0,
      "tw": 17.0,
      "tf": 30.5,
      "r1": 20.0
    },
    {
      "name": "UB460x280x213",
      "h": 495.0,
      "b": 285.0,
      "tw": 18.5,
      "tf": 33.5,
      "r1": 20.0
    },
    {
      "name": "UB460x280x235",
      "h": 501.0,
      "b": 287.0,
      "tw": 20.6,
      "tf": 36.6,
      "r1": 20.0
    },
    {
      "name": "UB460x280x260",
      "h": 509.0,
      "b": 289.0,
      "tw": 22.6,
      "tf": 40.4,
      "r1": 20.0
    },
    {
      "name": "UB460x280x286",
      "h": 517.0,
      "b": 291.0,
      "tw": 24.4,
      "tf": 44.4,
      "r1": 20.0
    },
    {
      "name": "UB460x280x315",
      "h": 525.0,
      "b": 293.0,
      "tw": 26.9,
      "tf": 48.5,
      "r1": 20.0
    },
    {
      "name": "UB533x165x66",
      "h": 525.0,
      "b": 165.0,
      "tw": 8.9,
      "tf": 11.4,
      "r1": 13.0
    },
    {
      "name": "UB533x165x74",
      "h": 529.0,
      "b": 166.0,
      "tw": 9.7,
      "tf": 13.6,
      "r1": 13.0
    },
    {
      "name": "UB533x165x85",
      "h": 535.0,
      "b": 166.0,
      "tw": 10.3,
      "tf": 16.5,
      "r1": 13.0
    },
    {
      "name": "UB533x210x82",
      "h": 528.0,
      "b": 209.0,
      "tw": 9.6,
      "tf": 13.2,
      "r1": 13.0
    },
    {
      "name": "UB533x210x92",
      "h": 533.0,
      "b": 209.0,
      "tw": 10.1,
      "tf": 15.6,
      "r1": 13.0
    },
    {
      "name": "UB533x210x101",
      "h": 537.0,
      "b": 210.0,
      "tw": 10.8,
      "tf": 17.4,
      "r1": 13.0
    },
    {
      "name": "UB533x210x109",
      "h": 540.0,
      "b": 211.0,
      "tw": 11.6,
      "tf": 18.8,
      "r1": 13.0
    },
    {
      "name": "UB533x210x122",
      "h": 544.0,
      "b": 212.0,
      "tw": 12.7,
      "tf": 21.3,
      "r1": 13.0
    },
    {
      "name": "UB533x210x138",
      "h": 549.0,
      "b": 214.0,
      "tw": 14.7,
      "tf": 23.6,
      "r1": 13.0
    },
    {
      "name": "UB533x312x150",
      "h": 542.0,
      "b": 312.0,
      "tw": 12.7,
      "tf": 20.3,
      "r1": 13.0
    },
    {
      "name": "UB533x312x165",
      "h": 546.0,
      "b": 313.0,
      "tw": 14.0,
      "tf": 22.2,
      "r1": 13.0
    },
    {
      "name": "UB533x312x182",
      "h": 551.0,
      "b": 314.0,
      "tw": 15.2,
      "tf": 24.4,
      "r1": 13.0
    },
    {
      "name": "UB533x312x196",
      "h": 554.0,
      "b": 316.0,
      "tw": 16.5,
      "tf": 26.3,
      "r1": 13.0
    },
    {
      "name": "UB533x312x219",
      "h": 560.0,
      "b": 317.0,
      "tw": 18.3,
      "tf": 29.2,
      "r1": 13.0
    },
    {
      "name": "UB533x312x248",
      "h": 571.0,
      "b": 315.0,
      "tw": 19.0,
      "tf": 34.5,
      "r1": 13.0
    },
    {
      "name": "UB533x312x272",
      "h": 577.0,
      "b": 320.0,
      "tw": 21.1,
      "tf": 37.6,
      "r1": 13.0
    },
    {
      "name": "UB610x178x82",
      "h": 599.0,
      "b": 178.0,
      "tw": 10.0,
      "tf": 12.8,
      "r1": 20.0
    },
    {
      "name": "UB610x178x92",
      "h": 603.0,
      "b": 179.0,
      "tw": 10.9,
      "tf": 15.0,
      "r1": 20.0
    },
    {
      "name": "UB610x178x100",
      "h": 607.0,
      "b": 179.0,
      "tw": 11.3,
      "tf": 17.2,
      "r1": 20.0
    },
    {
      "name": "UB610x229x101",
      "h": 603.0,
      "b": 228.0,
      "tw": 10.5,
      "tf": 14.8,
      "r1": 20.0
    },
    {
      "name": "UB610x229x113",
      "h": 608.0,
      "b": 228.0,
      "tw": 11.1,
      "tf": 17.3,
      "r1": 20.0
    },
    {
      "name": "UB610x229x125",
      "h": 612.0,
      "b": 229.0,
      "tw": 11.9,
      "tf": 19.6,
      "r1": 20.0
    },
    {
      "name": "UB610x229x140",
      "h": 617.0,
      "b": 230.0,
      "tw": 13.1,
      "tf": 22.1,
      "r1": 20.0
    },
    {
      "name": "UB610x305x149",
      "h": 612.0,
      "b": 305.0,
      "tw": 11.8,
      "tf": 19.7,
      "r1": 20.0
    },
    {
      "name": "UB610x305x179",
      "h": 620.0,
      "b": 307.0,
      "tw": 14.1,
      "tf": 23.6,
      "r1": 20.0
    },
    {
      "name": "UB610x305x238",
      "h": 636.0,
      "b": 311.0,
      "tw": 18.4,
      "tf": 31.4,
      "r1": 20.0
    },
    {
      "name": "UB610x324x155",
      "h": 611.0,
      "b": 324.0,
      "tw": 12.7,
      "tf": 19.0,
      "r1": 20.0
    },
    {
      "name": "UB610x324x174",
      "h": 616.0,
      "b": 325.0,
      "tw": 14.0,
      "tf": 21.6,
      "r1": 20.0
    },
    {
      "name": "UB610x324x195",
      "h": 622.0,
      "b": 327.0,
      "tw": 15.4,
      "tf": 24.4,
      "r1": 20.0
    },
    {
      "name": "UB610x324x217",
      "h": 628.0,
      "b": 328.0,
      "tw": 16.5,
      "tf": 27.7,
      "r1": 20.0
    },
    {
      "name": "UB610x324x241",
      "h": 635.0,
      "b": 329.0,
      "tw": 17.9,
      "tf": 31.0,
      "r1": 20.0
    },
    {
      "name": "UB610x324x262",
      "h": 641.0,
      "b": 327.0,
      "tw": 19.0,
      "tf": 34.0,
      "r1": 20.0
    },
    {
      "name": "UB610x324x285",
      "h": 647.0,
      "b": 329.0,
      "tw": 20.6,
      "tf": 37.1,
      "r1": 20.0
    },
    {
      "name": "UB610x324x307",
      "h": 653.0,
      "b": 330.0,
      "tw": 22.1,
      "tf": 39.9,
      "r1": 20.0
    },
    {
      "name": "UB610x324x341",
      "h": 661.0,
      "b": 333.0,
      "tw": 24.4,
      "tf": 43.9,
      "r1": 20.0
    },
    {
      "name": "UB610x324x372",
      "h": 669.0,
      "b": 335.0,
      "tw": 26.4,
      "tf": 48.0,
      "r1": 20.0
    },
    {
      "name": "UB686x254x125",
      "h": 678.0,
      "b": 253.0,
      "tw": 11.7,
      "tf": 16.2,
      "r1": 20.0
    },
    {
      "name": "UB686x254x140",
      "h": 684.0,
      "b": 254.0,
      "tw": 12.4,
      "tf": 19.0,
      "r1": 20.0
    },
    {
      "name": "UB686x254x152",
      "h": 688.0,
      "b": 254.0,
      "tw": 13.2,
      "tf": 21.0,
      "r1": 20.0
    },
    {
      "name": "UB686x254x170",
      "h": 693.0,
      "b": 256.0,
      "tw": 14.5,
      "tf": 23.7,
      "r1": 20.0
    },
    {
      "name": "UB762x267x134",
      "h": 750.0,
      "b": 264.0,
      "tw": 12.0,
      "tf": 15.5,
      "r1": 20.0
    },
    {
      "name": "UB762x267x147",
      "h": 754.0,
      "b": 265.0,
      "tw": 12.8,
      "tf": 17.5,
      "r1": 20.0
    },
    {
      "name": "UB762x267x161",
      "h": 758.0,
      "b": 266.0,
      "tw": 13.8,
      "tf": 19.3,
      "r1": 20.0
    },
    {
      "name": "UB762x267x173",
      "h": 762.0,
      "b": 267.0,
      "tw": 14.3,
      "tf": 21.6,
      "r1": 20.0
    },
    {
      "name": "UB762x267x185",
      "h": 766.0,
      "b": 267.0,
      "tw": 14.9,
      "tf": 23.6,
      "r1": 20.0
    },
    {
      "name": "UB762x267x197",
      "h": 770.0,
      "b": 268.0,
      "tw": 15.6,
      "tf": 25.4,
      "r1": 20.0
    },
    {
      "name": "UB838x292x176",
      "h": 835.0,
      "b": 292.0,
      "tw": 14.0,
      "tf": 18.8,
      "r1": 20.0
    },
    {
      "name": "UB838x292x194",
      "h": 841.0,
      "b": 292.0,
      "tw": 14.7,
      "tf": 21.7,
      "r1": 20.0
    },
    {
      "name": "UB838x292x210",
      "h": 846.0,
      "b": 293.0,
      "tw": 15.4,
      "tf": 24.4,
      "r1": 20.0
    },
    {
      "name": "UB838x292x226",
      "h": 851.0,
      "b": 294.0,
      "tw": 16.1,
      "tf": 26.8,
      "r1": 20.0
    },
    {
      "name": "UB914x305x201",
      "h": 903.0,
      "b": 303.0,
      "tw": 15.1,
      "tf": 20.2,
      "r1": 19.0
    },
    {
      "name": "UB914x305x224",
      "h": 910.0,
      "b": 304.0,
      "tw": 15.9,
      "tf": 23.9,
      "r1": 19.0
    },
    {
      "name": "UB914x305x239",
      "h": 915.0,
      "b": 305.0,
      "tw": 16.5,
      "tf": 25.9,
      "r1": 19.0
    },
    {
      "name": "UB914x305x253",
      "h": 918.0,
      "b": 306.0,
      "tw": 17.3,
      "tf": 27.9,
      "r1": 19.0
    },
    {
      "name": "UB914x305x271",
      "h": 923.0,
      "b": 307.0,
      "tw": 18.4,
      "tf": 30.0,
      "r1": 19.0
    },
    {
      "name": "UB914x305x289",
      "h": 927.0,
      "b": 308.0,
      "tw": 19.5,
      "tf": 32.0,
      "r1": 19.0
    },
    {
      "name": "UB914x305x313",
      "h": 932.0,
      "b": 309.0,
      "tw": 21.1,
      "tf": 34.5,
      "r1": 19.0
    },
    {
      "name": "UB914x419x343",
      "h": 912.0,
      "b": 418.0,
      "tw": 19.4,
      "tf": 32.0,
      "r1": 24.0
    },
    {
      "name": "UB914x419x365",
      "h": 916.0,
      "b": 419.0,
      "tw": 20.3,
      "tf": 34.3,
      "r1": 24.0
    },
    {
      "name": "UB914x419x388",
      "h": 921.0,
      "b": 420.0,
      "tw": 21.4,
      "tf": 36.6,
      "r1": 24.0
    },
    {
      "name": "UB1016x305x222",
      "h": 970.0,
      "b": 300.0,
      "tw": 16.0,
      "tf": 21.1,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x249",
      "h": 980.0,
      "b": 300.0,
      "tw": 16.5,
      "tf": 26.0,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x272",
      "h": 990.0,
      "b": 300.0,
      "tw": 16.5,
      "tf": 31.0,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x314",
      "h": 1000.0,
      "b": 300.0,
      "tw": 19.1,
      "tf": 35.9,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x349",
      "h": 1008.0,
      "b": 302.0,
      "tw": 21.1,
      "tf": 40.0,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x393",
      "h": 1016.0,
      "b": 303.0,
      "tw": 24.4,
      "tf": 43.9,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x437",
      "h": 1026.0,
      "b": 305.0,
      "tw": 26.9,
      "tf": 49.0,
      "r1": 30.0
    },
    {
      "name": "UB1016x305x487",
      "h": 1036.0,
      "b": 308.0,
      "tw": 30.0,
      "tf": 54.1,
      "r1": 30.0
    }
  ],
  "UC Sections": [
    {
      "name": "UC152x152x23",
      "h": 152.0,
      "b": 152.0,
      "tw": 5.8,
      "tf": 6.8,
      "r1": 8.0
    },
    {
      "name": "UC152x152x30",
      "h": 158.0,
      "b": 153.0,
      "tw": 6.5,
      "tf": 9.4,
      "r1": 8.0
    },
    {
      "name": "UC152x152x37",
      "h": 162.0,
      "b": 154.0,
      "tw": 8.0,
      "tf": 11.5,
      "r1": 8.0
    },
    {
      "name": "UC152x152x44",
      "h": 166.0,
      "b": 156.0,
      "tw": 9.5,
      "tf": 13.6,
      "r1": 8.0
    },
    {
      "name": "UC152x152x51",
      "h": 170.0,
      "b": 157.0,
      "tw": 11.0,
      "tf": 15.7,
      "r1": 8.0
    },
    {
      "name": "UC203x203x46",
      "h": 203.0,
      "b": 204.0,
      "tw": 7.2,
      "tf": 11.0,
      "r1": 13.0
    },
    {
      "name": "UC203x203x52",
      "h": 206.0,
      "b": 204.0,
      "tw": 7.9,
      "tf": 12.5,
      "r1": 13.0
    },
    {
      "name": "UC203x203x60",
      "h": 210.0,
      "b": 206.0,
      "tw": 9.4,
      "tf": 14.2,
      "r1": 13.0
    },
    {
      "name": "UC203x203x71",
      "h": 216.0,
      "b": 206.0,
      "tw": 10.0,
      "tf": 17.3,
      "r1": 13.0
    },
    {
      "name": "UC203x203x86",
      "h": 222.0,
      "b": 209.0,
      "tw": 12.7,
      "tf": 20.5,
      "r1": 13.0
    },
    {
      "name": "UC203x203x100",
      "h": 229.0,
      "b": 210.0,
      "tw": 14.5,
      "tf": 23.7,
      "r1": 13.0
    },
    {
      "name": "UC203x203x113",
      "h": 235.0,
      "b": 212.0,
      "tw": 16.3,
      "tf": 26.9,
      "r1": 13.0
    },
    {
      "name": "UC203x203x127",
      "h": 241.0,
      "b": 214.0,
      "tw": 18.1,
      "tf": 30.1,
      "r1": 13.0
    },
    {
      "name": "UC254x254x73",
      "h": 254.0,
      "b": 255.0,
      "tw": 8.6,
      "tf": 14.2,
      "r1": 20.0
    },
    {
      "name": "UC254x254x81",
      "h": 256.0,
      "b": 255.0,
      "tw": 9.4,
      "tf": 15.6,
      "r1": 20.0
    },
    {
      "name": "UC254x254x89",
      "h": 260.0,
      "b": 256.0,
      "tw": 10.3,
      "tf": 17.3,
      "r1": 20.0
    },
    {
      "name": "UC254x254x101",
      "h": 264.0,
      "b": 257.0,
      "tw": 11.9,
      "tf": 19.6,
      "r1": 20.0
    },
    {
      "name": "UC254x254x107",
      "h": 267.0,
      "b": 259.0,
      "tw": 12.8,
      "tf": 20.5,
      "r1": 20.0
    },
    {
      "name": "UC254x254x115",
      "h": 269.0,
      "b": 259.0,
      "tw": 13.5,
      "tf": 22.1,
      "r1": 20.0
    },
    {
      "name": "UC254x254x132",
      "h": 276.0,
      "b": 261.0,
      "tw": 15.3,
      "tf": 25.3,
      "r1": 20.0
    },
    {
      "name": "UC254x254x149",
      "h": 282.0,
      "b": 263.0,
      "tw": 17.3,
      "tf": 28.4,
      "r1": 20.0
    },
    {
      "name": "UC254x254x167",
      "h": 289.0,
      "b": 265.0,
      "tw": 19.2,
      "tf": 31.7,
      "r1": 20.0
    },
    {
      "name": "UC305x305x97",
      "h": 308.0,
      "b": 305.0,
      "tw": 9.9,
      "tf": 15.4,
      "r1": 20.0
    },
    {
      "name": "UC305x305x107",
      "h": 311.0,
      "b": 306.0,
      "tw": 10.9,
      "tf": 17.0,
      "r1": 20.0
    },
    {
      "name": "UC305x305x118",
      "h": 314.0,
      "b": 307.0,
      "tw": 12.0,
      "tf": 18.7,
      "r1": 20.0
    },
    {
      "name": "UC305x305x129",
      "h": 318.0,
      "b": 308.0,
      "tw": 13.1,
      "tf": 20.6,
      "r1": 20.0
    },
    {
      "name": "UC305x305x137",
      "h": 320.0,
      "b": 309.0,
      "tw": 13.8,
      "tf": 21.7,
      "r1": 20.0
    },
    {
      "name": "UC305x305x143",
      "h": 323.0,
      "b": 309.0,
      "tw": 14.0,
      "tf": 22.9,
      "r1": 20.0
    },
    {
      "name": "UC305x305x158",
      "h": 327.0,
      "b": 311.0,
      "tw": 15.8,
      "tf": 25.0,
      "r1": 20.0
    },
    {
      "name": "UC305x305x179",
      "h": 333.0,
      "b": 313.0,
      "tw": 18.0,
      "tf": 28.1,
      "r1": 20.0
    },
    {
      "name": "UC305x305x198",
      "h": 340.0,
      "b": 314.0,
      "tw": 19.1,
      "tf": 31.4,
      "r1": 20.0
    },
    {
      "name": "UC305x305x202",
      "h": 341.0,
      "b": 315.0,
      "tw": 20.1,
      "tf": 31.8,
      "r1": 20.0
    },
    {
      "name": "UC305x305x226",
      "h": 348.0,
      "b": 317.0,
      "tw": 22.1,
      "tf": 35.6,
      "r1": 20.0
    },
    {
      "name": "UC305x305x240",
      "h": 352.0,
      "b": 318.0,
      "tw": 23.0,
      "tf": 37.7,
      "r1": 20.0
    },
    {
      "name": "UC305x305x253",
      "h": 356.0,
      "b": 319.0,
      "tw": 24.4,
      "tf": 39.6,
      "r1": 20.0
    },
    {
      "name": "UC305x305x283",
      "h": 365.0,
      "b": 322.0,
      "tw": 26.8,
      "tf": 44.1,
      "r1": 20.0
    },
    {
      "name": "UC356x368x129",
      "h": 356.0,
      "b": 369.0,
      "tw": 10.4,
      "tf": 17.5,
      "r1": 20.0
    },
    {
      "name": "UC356x368x134",
      "h": 356.0,
      "b": 369.0,
      "tw": 11.2,
      "tf": 18.0,
      "r1": 20.0
    },
    {
      "name": "UC356x368x147",
      "h": 360.0,
      "b": 370.0,
      "tw": 12.3,
      "tf": 19.8,
      "r1": 20.0
    },
    {
      "name": "UC356x368x153",
      "h": 362.0,
      "b": 370.0,
      "tw": 12.3,
      "tf": 20.7,
      "r1": 20.0
    },
    {
      "name": "UC356x368x162",
      "h": 364.0,
      "b": 371.0,
      "tw": 13.3,
      "tf": 21.8,
      "r1": 20.0
    },
    {
      "name": "UC356x368x177",
      "h": 368.0,
      "b": 373.0,
      "tw": 14.4,
      "tf": 23.8,
      "r1": 20.0
    },
    {
      "name": "UC356x368x179",
      "h": 368.0,
      "b": 374.0,
      "tw": 15.0,
      "tf": 23.9,
      "r1": 20.0
    },
    {
      "name": "UC356x368x196",
      "h": 372.0,
      "b": 374.0,
      "tw": 16.4,
      "tf": 26.2,
      "r1": 20.0
    },
    {
      "name": "UC356x368x202",
      "h": 375.0,
      "b": 375.0,
      "tw": 16.5,
      "tf": 27.0,
      "r1": 20.0
    },
    {
      "name": "UC356x406x216",
      "h": 375.0,
      "b": 394.0,
      "tw": 17.3,
      "tf": 27.7,
      "r1": 20.0
    },
    {
      "name": "UC356x406x235",
      "h": 381.0,
      "b": 395.0,
      "tw": 18.4,
      "tf": 30.2,
      "r1": 20.0
    },
    {
      "name": "UC356x406x262",
      "h": 387.0,
      "b": 398.0,
      "tw": 21.1,
      "tf": 33.3,
      "r1": 20.0
    },
    {
      "name": "UC356x406x287",
      "h": 394.0,
      "b": 399.0,
      "tw": 22.6,
      "tf": 36.5,
      "r1": 20.0
    },
    {
      "name": "UC356x406x314",
      "h": 399.0,
      "b": 401.0,
      "tw": 24.9,
      "tf": 39.6,
      "r1": 20.0
    },
    {
      "name": "UC356x406x340",
      "h": 406.0,
      "b": 403.0,
      "tw": 26.6,
      "tf": 42.9,
      "r1": 20.0
    },
    {
      "name": "UC356x406x347",
      "h": 407.0,
      "b": 404.0,
      "tw": 27.2,
      "tf": 43.7,
      "r1": 20.0
    },
    {
      "name": "UC356x406x382",
      "h": 416.0,
      "b": 406.0,
      "tw": 29.8,
      "tf": 48.0,
      "r1": 20.0
    },
    {
      "name": "UC356x406x393",
      "h": 419.0,
      "b": 407.0,
      "tw": 30.6,
      "tf": 49.2,
      "r1": 20.0
    },
    {
      "name": "UC356x406x421",
      "h": 425.0,
      "b": 409.0,
      "tw": 32.8,
      "tf": 52.6,
      "r1": 20.0
    },
    {
      "name": "UC356x406x467",
      "h": 437.0,
      "b": 412.0,
      "tw": 35.8,
      "tf": 58.0,
      "r1": 20.0
    },
    {
      "name": "UC356x406x509",
      "h": 446.0,
      "b": 416.0,
      "tw": 39.1,
      "tf": 62.7,
      "r1": 20.0
    },
    {
      "name": "UC356x406x551",
      "h": 456.0,
      "b": 418.0,
      "tw": 42.1,
      "tf": 67.5,
      "r1": 20.0
    },
    {
      "name": "UC356x406x592",
      "h": 465.0,
      "b": 421.0,
      "tw": 45.0,
      "tf": 72.3,
      "r1": 20.0
    },
    {
      "name": "UC356x406x634",
      "h": 475.0,
      "b": 424.0,
      "tw": 47.6,
      "tf": 77.0,
      "r1": 20.0
    }
  ],
  "UBP Sections": [
    {
      "name": "UBP203x203x45",
      "h": 200.0,
      "b": 206.0,
      "tw": 9.5,
      "tf": 9.5,
      "r1": 10.0
    },
    {
      "name": "UBP203x203x54",
      "h": 204.0,
      "b": 208.0,
      "tw": 11.3,
      "tf": 11.4,
      "r1": 10.0
    },
    {
      "name": "UBP254x254x63",
      "h": 247.0,
      "b": 257.0,
      "tw": 10.6,
      "tf": 10.7,
      "r1": 20.0
    },
    {
      "name": "UBP254x254x71",
      "h": 250.0,
      "b": 258.0,
      "tw": 12.0,
      "tf": 12.0,
      "r1": 20.0
    },
    {
      "name": "UBP254x254x85",
      "h": 254.0,
      "b": 260.0,
      "tw": 14.4,
      "tf": 14.3,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x79",
      "h": 299.0,
      "b": 306.0,
      "tw": 11.0,
      "tf": 11.1,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x88",
      "h": 302.0,
      "b": 308.0,
      "tw": 12.4,
      "tf": 12.3,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x95",
      "h": 304.0,
      "b": 309.0,
      "tw": 13.3,
      "tf": 13.3,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x110",
      "h": 308.0,
      "b": 311.0,
      "tw": 15.3,
      "tf": 15.4,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x126",
      "h": 312.0,
      "b": 313.0,
      "tw": 17.5,
      "tf": 17.6,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x149",
      "h": 318.0,
      "b": 316.0,
      "tw": 20.6,
      "tf": 20.7,
      "r1": 20.0
    },
    {
      "name": "UBP305x305x186",
      "h": 328.0,
      "b": 321.0,
      "tw": 25.5,
      "tf": 25.6,
      "r1": 2.0
    },
    {
      "name": "UBP305x305x223",
      "h": 338.0,
      "b": 326.0,
      "tw": 30.3,
      "tf": 30.4,
      "r1": 20.0
    },
    {
      "name": "UBP356x368x109",
      "h": 346.0,
      "b": 371.0,
      "tw": 12.8,
      "tf": 12.9,
      "r1": 20.0
    },
    {
      "name": "UBP356x368x133",
      "h": 352.0,
      "b": 374.0,
      "tw": 15.6,
      "tf": 15.7,
      "r1": 20.0
    },
    {
      "name": "UBP356x368x152",
      "h": 356.0,
      "b": 376.0,
      "tw": 17.8,
      "tf": 17.9,
      "r1": 20.0
    },
    {
      "name": "UBP356x368x174",
      "h": 361.0,
      "b": 378.0,
      "tw": 20.3,
      "tf": 20.4,
      "r1": 20.0
    }
  ]
};
